import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer
} from "@angular/core";

import {
  AccessibilityWidgetOptions,
  AccessibilityWidgetService
} from "../services/accessibility/accessibility-widget.service";

/**
 * Registra o carregamento do widget de acessibilidade na inicialização do app.
 * Sem `accountId` configurado, o provider é inócuo (o service não injeta nada).
 */
export function provideAccessibilityWidget(
  options: AccessibilityWidgetOptions
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(AccessibilityWidgetService).load(options);
    })
  ]);
}
